export default {
  path: '/connexion_users',
  name: 'connexion_users',
  component: () => import('../components/connexionuser/Layout'),
  redirect: { name: 'ConnexionUserList' },
  meta: {
    breadcrumb: 'administration.user.connexionusers',
  },
  children: [
    {
      name: 'ConnexionUserList',
      path: '',
      component: () => import('../views/connexionuser/List'),
      meta: {
        breadcrumb: 'global.list',
      },

    },
    {
      name: 'ConnexionUserShow',
      path: ':id',
      component: () => import('../views/connexionuser/Show'),
      meta: {
        breadcrumb: 'administration.user.connexionuser',
      },
    }
  ]
};
